import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ReservationsTabsEnums} from '../../../enums/reservations-enums';
import {NotificationsModelTypeAdmin} from "../../../enums/notification-enums";
import {Subscription} from "rxjs";
import {WebsocketsHelperService} from "../../../services/helpers/websockets-helper.service";

@Component({
  selector: 'gr-reservations',
  templateUrl: './reservations.component.html',
})
export class ReservationsComponent implements OnInit {
  activeTab: any = ReservationsTabsEnums.reservations;
  protected readonly ReservationsTabsEnums = ReservationsTabsEnums;
  giftsNotificationsCount!: number;
  reservationsNotificationsCount!: number;
  wsNotificationsSubscription= new Subscription();

  constructor(private websocketsHelperService: WebsocketsHelperService) {
  }

  ngOnInit(): void {
    console.log('booop')
    this.wsNotificationsSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
      console.log('wsNotificationsSubscription u RESERVATIONS', res);
      if (res.type === NotificationsModelTypeAdmin.reservationCreatedAdmin) {
        this.reservationsNotificationsCount++;
      }
      if (res.type === NotificationsModelTypeAdmin.reservationCreatedAdminGifts) {
        this.giftsNotificationsCount++;
      }
    });
  }
}
